/* DRG CUSTOM (FINAL PERFORMANCE VERSION v2) */

let drgFilterTimer = null;
let drgAbortController = null;
const drgFilterCache = new Map();
let drgLastAppliedUrl = '';
let drgLoadingRaf = null;

/* ------------------------------ */

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('#filters-drawer') || document;
  const filterState = createFilterState();

  const forms = document.querySelectorAll('form[action*="/collections"]');
  forms.forEach((form) => {
    form.setAttribute('data-drg-disabled', 'true');
  });

  hydrateStateFromDOM(root, filterState);

  window.drgFilterState = filterState;
});

/* ------------------------------
   Loading演出
------------------------------ */

function showLoadingState() {
  if (drgLoadingRaf) cancelAnimationFrame(drgLoadingRaf);

  drgLoadingRaf = requestAnimationFrame(() => {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;
    grid.style.opacity = '0.6';
  });
}

function hideLoadingState() {
  if (drgLoadingRaf) cancelAnimationFrame(drgLoadingRaf);

  const grid = document.querySelector('#product-grid');
  if (!grid) return;
  grid.style.opacity = '1';
}

/* ------------------------------ */

function createFilterState() {
  return {
    selected: new Map(),
    requestId: 0
  };
}

/* ------------------------------ */

function hydrateStateFromDOM(root, state) {
  state.selected.clear();

  const inputs = root.querySelectorAll('input[name], select[name]');

  inputs.forEach((input) => {
    if (!input.name) return;

    const name = input.name;

    if (input.type === 'checkbox') {
      if (input.checked) {
        const values = state.selected.get(name) || [];
        values.push(input.value);
        state.selected.set(name, values);
      }
      return;
    }

    if (input.type === 'radio') {
      if (input.checked) {
        state.selected.set(name, input.value);
      }
      return;
    }

    if (input.value) {
      state.selected.set(name, input.value);
    }
  });
}

/* ------------------------------
   クリック瞬間に反応を出す
------------------------------ */

document.addEventListener('click', (e) => {
  const input = e.target.closest('input[type="checkbox"], input[type="radio"]');
  if (!input) return;

  const form = input.closest('form');
  if (!form || !form.hasAttribute('data-drg-disabled')) return;

  showLoadingState();
});

/* ------------------------------ */

document.addEventListener('change', (e) => {
  const input = e.target;
  if (!input || !input.name) return;

  const form = input.closest('form');
  if (form && form.hasAttribute('data-drg-disabled')) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  const state = window.drgFilterState;
  if (!state) return;

  updateState(input, state);
  requestFilterDebounced(state);
});

/* ------------------------------ */

function updateState(input, state) {
  const name = input.name;

  if (input.type === 'checkbox') {
    let values = state.selected.get(name) || [];

    if (input.checked) {
      if (!values.includes(input.value)) values.push(input.value);
    } else {
      values = values.filter((v) => v !== input.value);
    }

    if (values.length) {
      state.selected.set(name, values);
    } else {
      state.selected.delete(name);
    }

    return;
  }

  if (input.type === 'radio') {
    state.selected.set(name, input.value);
    return;
  }

  if (input.value) {
    state.selected.set(name, input.value);
  } else {
    state.selected.delete(name);
  }
}

/* ------------------------------ */

function buildURL(state) {
  const params = new URLSearchParams();

  state.selected.forEach((value, key) => {
    if (Array.isArray(value)) {
      value.forEach((v) => params.append(key, v));
    } else {
      params.set(key, value);
    }
  });

  return `${location.pathname}?${params.toString()}`;
}

/* ------------------------------
   debounce
------------------------------ */

function requestFilterDebounced(state) {
  clearTimeout(drgFilterTimer);
  drgFilterTimer = setTimeout(() => {
    requestFilter(state);
  }, 80);
}

/* ------------------------------
   request + cache + abort
------------------------------ */

async function requestFilter(state) {
  const url = buildURL(state);

  // 同じURLなら何もしない
  if (url === drgLastAppliedUrl) {
    hideLoadingState();
    return;
  }

  state.requestId++;
  const id = state.requestId;

  if (drgAbortController) {
    drgAbortController.abort();
  }

  drgAbortController = new AbortController();
  const signal = drgAbortController.signal;

  // キャッシュヒットなら即反映
  if (drgFilterCache.has(url)) {
    const html = drgFilterCache.get(url);
    applyFilterResult(html, id, state, url);
    return;
  }

  const sectionEl = document.querySelector('[id^="shopify-section-"]');
  if (!sectionEl) {
    hideLoadingState();
    return;
  }

  const sectionId = sectionEl.id.replace('shopify-section-', '');

  try {
    const joiner = url.includes('?') ? '&' : '?';
    const res = await fetch(`${url}${joiner}sections=${sectionId}`, { signal });
    const json = await res.json();
    const html = json[sectionId];

    if (!html) {
      hideLoadingState();
      return;
    }

    drgFilterCache.set(url, html);
    applyFilterResult(html, id, state, url);
  } catch (err) {
    if (err.name === 'AbortError') return;

    console.error('[DRG] request error', err);
    hideLoadingState();
  }
}

/* ------------------------------
   共通描画処理
------------------------------ */

function applyFilterResult(html, id, state, url) {
  if (id !== state.requestId) return;

  const count = extractCount(html);
  if (id !== state.requestId) return;

  renderCount(count);

  requestAnimationFrame(() => {
    if (id !== state.requestId) return;

    const grid = extractGrid(html);
    renderGrid(grid);

    drgLastAppliedUrl = url;
    hideLoadingState();
  });
}

/* ------------------------------ */

function extractCount(html) {
  const temp = document.createElement('div');
  temp.innerHTML = html;

  const desktopCount = temp.querySelector('#ProductCountDesktop');
  if (desktopCount) {
    const match = desktopCount.textContent.match(/(\d+)/);
    return match ? match[1] : null;
  }

  const text = temp.textContent || '';
  const match = text.match(/(\d+)\s+products/i);
  return match ? match[1] : null;
}

function renderCount(text) {
  if (!text) return;

  const number = String(text).replace(/[^\d]/g, '');
  if (!number) return;

  const mobile = document.querySelector('[data-drg-header-items-count]');
  if (mobile) mobile.textContent = number;

  const pc = document.querySelector('#ProductCountDesktop');
  if (pc) pc.textContent = `${number} products`;
}

/* ------------------------------ */

function extractGrid(html) {
  const temp = document.createElement('div');
  temp.innerHTML = html;

  return (
    temp.querySelector('#ProductGridContainer') ||
    temp.querySelector('.product-grid')
  );
}

function renderGrid(newGrid) {
  if (!newGrid) return;

  const current = document.querySelector('#product-grid');
  const next = newGrid.querySelector('#product-grid');

  if (!current || !next) return;

  const currentItems = Array.from(current.children);
  const nextItems = Array.from(next.children);

  // 👇 差が大きい場合は丸ごと入れ替え（軽い）
  const diff = Math.abs(currentItems.length - nextItems.length);

  if (diff > 12) {
    current.innerHTML = next.innerHTML;
    return;
  }

  // 👇 通常は差分更新
  const max = Math.max(currentItems.length, nextItems.length);

  for (let i = 0; i < max; i++) {
    const currentItem = currentItems[i];
    const nextItem = nextItems[i];

    if (!currentItem && nextItem) {
      current.appendChild(nextItem.cloneNode(true));
      continue;
    }

    if (currentItem && !nextItem) {
      currentItem.remove();
      continue;
    }

    if (currentItem && nextItem) {
      if (currentItem.innerHTML !== nextItem.innerHTML) {
        currentItem.replaceWith(nextItem.cloneNode(true));
      }
    }
  }
}

/* DRG CUSTOM (START) 20260422 | swipe final mid notch test */

document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#DrgMobileFacetsForm');
  const shell = document.querySelector('#DrgMobileFacetsSheet');
  const handle = form?.querySelector('[data-drg-handle]');
  const header = form?.querySelector('[data-drg-header]');
  const closeBtn = form?.querySelector('[data-drg-close]');

  if (!form || !shell || !handle || !header) return;

  const DRAG = {
    axisLockThreshold: 8,
    returnDuration: 180,
    topGap: 12,

    // 3つの基準位置
    lowRatio: 0.25,
    midRatio: 0.55,
    highRatio: 0.85,

    // LOWを超えてこれだけ下に引いたらclose
    closeThreshold: 72,

    // MID ノッチ設定
    midNotchBand: 10,        // MIDの±何pxでノッチ候補に入るか
    midNotchHold: 8,         // 一瞬止まる量
    midNotchRelease: 12      // ここまで余分に動かせば抜ける
  };

  let startX = 0;
  let startY = 0;
  let isDragging = false;
  let lockAxis = null;

  let currentHeight = 0;
  let dragStartHeight = 0;
  let hasUserHeight = false;
  let overshootY = 0;

  // MIDノッチ用
  let midNotchActive = false;
  let midNotchDirection = 0;   // -1 = 下方向通過中 / 1 = 上方向通過中
  let midNotchAnchor = 0;      // ノッチ突入時の基準dy
  let midNotchLockedHeight = 0;

  function isOpen() {
    return shell.classList.contains('is-open');
  }

  function getViewportHeight() {
    return window.visualViewport ? window.visualViewport.height : window.innerHeight;
  }

  function getMaxHeight() {
    return Math.max(0, getViewportHeight() - DRAG.topGap);
  }

  function clamp(v, min, max) {
    return Math.min(Math.max(v, min), max);
  }

  function getLowHeight() {
    return clamp(
      Math.round(getViewportHeight() * DRAG.lowRatio),
      0,
      getMaxHeight()
    );
  }

  function getMidHeight() {
    return clamp(
      Math.round(getViewportHeight() * DRAG.midRatio),
      getLowHeight(),
      getMaxHeight()
    );
  }

  function getHighHeight() {
    return clamp(
      Math.round(getViewportHeight() * DRAG.highRatio),
      getMidHeight(),
      getMaxHeight()
    );
  }

  function setShellHeight(h) {
    shell.style.height = `${h}px`;
  }

  function setShellOffset(y) {
    shell.style.transform = y > 0 ? `translate3d(0, ${y}px, 0)` : '';
  }

  function normalizeCurrentHeight() {
    const lowHeight = getLowHeight();
    const maxHeight = getMaxHeight();

    if (!hasUserHeight && !currentHeight) {
      currentHeight = getMidHeight();
    } else if (!currentHeight) {
      currentHeight = getMidHeight();
    }

    currentHeight = clamp(currentHeight, lowHeight, maxHeight);
  }

  function animateTo({ height = currentHeight, offset = 0, callback } = {}) {
    currentHeight = height;
    shell.style.transition = `height ${DRAG.returnDuration}ms ease, transform ${DRAG.returnDuration}ms ease`;
    setShellHeight(height);
    setShellOffset(offset);

    window.setTimeout(() => {
      shell.style.transition = '';
      if (offset === 0) setShellOffset(0);
      if (typeof callback === 'function') callback();
    }, DRAG.returnDuration);
  }

  function closeDrawer() {
    shell.style.transition = `transform ${DRAG.returnDuration}ms ease`;
    shell.style.transform = `translate3d(0, ${getViewportHeight()}px, 0)`;

    window.setTimeout(() => {
      shell.style.transition = '';
      shell.style.transform = '';
      closeBtn?.click();
    }, DRAG.returnDuration);
  }

  function getSnapTarget(height) {
    const lowHeight = getLowHeight();
    const midHeight = getMidHeight();
    const highHeight = getHighHeight();

    if (Math.abs(height - lowHeight) <= DRAG.lowSnapDistance) {
      return lowHeight;
    }

    if (Math.abs(height - midHeight) <= DRAG.midSnapDistance) {
      return midHeight;
    }

    if (Math.abs(height - highHeight) <= DRAG.highSnapDistance) {
      return highHeight;
    }

    return height;
  }

  function resetNotchState() {
    midNotchActive = false;
    midNotchDirection = 0;
    midNotchAnchor = 0;
    midNotchLockedHeight = 0;
  }

  function tryApplyMidNotch(rawHeight, dy) {
    const midHeight = getMidHeight();

    // dy > 0: 下へ引いている（高さは下がる）
    // dy < 0: 上へ引いている（高さは上がる）
    const direction = dy > 0 ? -1 : 1;

    if (!midNotchActive) {
      const inBand = Math.abs(rawHeight - midHeight) <= DRAG.midNotchBand;

      if (inBand && direction !== 0) {
        midNotchActive = true;
        midNotchDirection = direction;
        midNotchAnchor = dy;
        midNotchLockedHeight = midHeight + (direction * DRAG.midNotchHold);
      } else {
        return rawHeight;
      }
    }

    // 逆方向へ戻したら解除
    if ((direction !== 0) && (direction !== midNotchDirection)) {
      resetNotchState();
      return rawHeight;
    }

    const passed = Math.abs(dy - midNotchAnchor);

    // 一定距離以上さらに動かしたらノッチ解除
    if (passed >= DRAG.midNotchRelease) {
      resetNotchState();
      return rawHeight;
    }

    return midNotchLockedHeight;
  }

  function onStart(e) {
    if (!isOpen()) return;

    const t = e.touches[0];
    if (!t) return;

    normalizeCurrentHeight();
    setShellHeight(currentHeight);
    setShellOffset(0);

    startX = t.clientX;
    startY = t.clientY;
    dragStartHeight = currentHeight;
    isDragging = true;
    lockAxis = null;
    overshootY = 0;
    resetNotchState();

    shell.style.transition = 'none';
  }

  function onMove(e) {
    if (!isDragging || !isOpen()) return;

    const t = e.touches[0];
    if (!t) return;

    const dx = t.clientX - startX;
    const dy = t.clientY - startY;

    if (!lockAxis) {
      if (Math.abs(dx) > DRAG.axisLockThreshold) {
        lockAxis = 'x';
      } else if (Math.abs(dy) > DRAG.axisLockThreshold) {
        lockAxis = 'y';
      }
    }

    if (lockAxis !== 'y') return;

    e.preventDefault();

    const lowHeight = getLowHeight();
    const maxHeight = getMaxHeight();

    const rawHeight = dragStartHeight - dy;

    if (rawHeight >= lowHeight) {
      const notchedHeight = tryApplyMidNotch(rawHeight, dy);

      currentHeight = clamp(notchedHeight, lowHeight, maxHeight);
      overshootY = 0;
      setShellHeight(currentHeight);
      setShellOffset(0);
      return;
    }

    resetNotchState();

    currentHeight = lowHeight;
    overshootY = lowHeight - rawHeight;

    setShellHeight(lowHeight);
    setShellOffset(overshootY);
  }

  function onEnd() {
    if (!isDragging) return;

    isDragging = false;

    if (!isOpen()) return;

    normalizeCurrentHeight();
    resetNotchState();

    const lowHeight = getLowHeight();

    if (overshootY >= DRAG.closeThreshold) {
      closeDrawer();
      return;
    }

    if (overshootY > 0) {
      currentHeight = lowHeight;
      hasUserHeight = true;
      animateTo({ height: lowHeight, offset: 0 });
      return;
    }

    currentHeight = getSnapTarget(currentHeight);
    hasUserHeight = true;
    animateTo({ height: currentHeight, offset: 0 });
  }

  [handle, header].forEach((el) => {
    el.addEventListener('touchstart', onStart, { passive: true });
    el.addEventListener('touchmove', onMove, { passive: false });
    el.addEventListener('touchend', onEnd);
    el.addEventListener('touchcancel', onEnd);
  });

  const observer = new MutationObserver(() => {
    if (isOpen()) {
      if (!hasUserHeight) {
        currentHeight = getMidHeight();
      }
      normalizeCurrentHeight();
      setShellHeight(currentHeight);
      setShellOffset(0);
    }
  });

  observer.observe(shell, {
    attributes: true,
    attributeFilter: ['class']
  });

  window.addEventListener('resize', () => {
    const lowHeight = getLowHeight();
    const maxHeight = getMaxHeight();

    if (!hasUserHeight) {
      currentHeight = getMidHeight();
    } else {
      currentHeight = clamp(currentHeight, lowHeight, maxHeight);
    }

    setShellHeight(currentHeight);
    setShellOffset(0);
  });
});

/* DRG CUSTOM (END) 20260422 | swipe final mid notch test */